import React, { useRef } from 'react';
import { motion, useReducedMotion } from 'motion/react';
import SectionHeader from '../ui/SectionHeader';
import './Gallery.css';

const PUB = process.env.PUBLIC_URL;

const IMAGES = [
  { src: '/agents-vs-wall-street.webp', caption: 'Agents vs Wall Street Hackathon in London', date: 'August 2026', wide: true },
  { src: '/lcw.png', caption: 'LCWaikiki Challengers', date: 'May 2026' },
  { src: '/foodathon.png', caption: 'TıklaGelsin × ATPCapital Foodathon', date: 'April 2026' },
  { src: '/4.jpeg', caption: 'HızlıOkuyo by PSH EdTech', date: '2026' },
  { src: '/2.jpeg', caption: 'Curiosity Technology at Teknofest', date: '2025' },
  { src: '/3.jpeg', caption: 'Autoliv Turkey', date: '2024' },
  { src: '/5.jpg', caption: 'Toyota Turkey warehouse', date: '2023' },
  { src: '/6.jpg', caption: 'Toyota Turkey', date: '2023' },
];

const Gallery = () => {
  const reduce = useReducedMotion();
  const viewportRef = useRef(null);

  return (
    <section id="gallery" className="section gal">
      <div className="container">
        <SectionHeader eyebrow="gallery" title="Snapshots." lede="A few years in photos — drag to browse." />
      </div>

      <div className="gal-viewport" ref={viewportRef}>
        <motion.ul
          className="gal-track"
          drag="x"
          dragConstraints={viewportRef}
          dragElastic={0.08}
          dragTransition={{ power: 0.25, timeConstant: 220 }}
        >
          {IMAGES.map((img, i) => (
            <motion.li
              key={img.src}
              className={`gal-card ${img.wide ? 'gal-card--wide' : ''}`}
              style={{ rotate: reduce ? 0 : (i % 2 ? 2.2 : -2.2) }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '0px 0px -40px 0px' }}
              whileHover={reduce ? undefined : { rotate: 0, y: -8, scale: 1.02 }}
              transition={{ type: 'spring', stiffness: 260, damping: 20, delay: i * 0.05 }}
            >
              <figure>
                <img src={`${PUB}${img.src}`} alt={img.caption} loading="lazy" draggable="false" />
                <figcaption className="mono">
                  {img.caption}
                  {img.date && <span>{img.date}</span>}
                </figcaption>
              </figure>
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
};

export default Gallery;
